(() => {
  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => [...root.querySelectorAll(s)];

  $$('[data-filter-toggle]').forEach((button) => {
    const form = button.closest('.collection-filters');
    const panel = form?.querySelector('[data-filter-panel]');
    const close = panel?.querySelector('[data-filter-close]');
    const open = () => { panel?.classList.add('is-open'); document.body.classList.add('drawer-open'); close?.focus(); };
    const shut = () => { panel?.classList.remove('is-open'); document.body.classList.remove('drawer-open'); button.focus(); };
    button.addEventListener('click', open);
    close?.addEventListener('click', shut);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel?.classList.contains('is-open')) shut(); });
  });
})();